import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
} from "chart.js";
import {
  Card,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";

/* ======================
   ChartJS Registration
====================== */
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler
);

/* ======================
   Component
====================== */
const ChartStationTJ = () => {
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ======================
     Fetch Data
  ====================== */
  useEffect(() => {
    setLoading(true);

    axios
      .get("https://portaldata.jaktraffic.my.id/pqs/jli/feed/viewJliDatav2", {
        params: {
          page: 1,
          pto: "TJ",
          pageSize: 200,
        },
      })
      .then((res) => {
        const rows = res.data?.data ?? {};
        const counter = {};

        rows.forEach((item) => {
          if (item.station_destination) {
            const key = item.station_destination.split(" - ")[0];
            counter[key] = (counter[key] || 0) + 1;
          }
        });

        setLabels(Object.keys(counter));
        setValues(Object.values(counter));
      })
      .catch((err) => {
        console.error("Error fetching station data:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  /* ======================
     Chart Data
  ====================== */
  const data = useMemo(
    () => ({
      labels,
      datasets: [
        {
          data: values,
          borderColor: "#6366f1",
          borderWidth: 2,
          tension: 0.45,
          pointRadius: 3,
          pointBackgroundColor: "#6366f1",
          fill: true,
          backgroundColor: (ctx) => {
            const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 350);
            gradient.addColorStop(0, "rgba(99,102,241,0.35)");
            gradient.addColorStop(1, "rgba(99,102,241,0)");
            return gradient;
          },
        },
      ],
    }),
    [labels, values]
  );

  /* ======================
     Chart Options
  ====================== */
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "#111827",
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 10,
        cornerRadius: 8,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: "#6b7280",
          autoSkip: true,
          maxRotation: 0,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0,0,0,0.05)",
        },
        ticks: {
          color: "#6b7280",
        },
      },
    },
  };

  /* ======================
     Render
  ====================== */
  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 4,
        width: "100%",
        height: 420,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" fontWeight={700} mb={2}>
        Jumlah Tujuan Halte
      </Typography>

      <Box
        sx={{
          flex: 1,
          position: "relative",
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <Line data={data} options={options} />
        )}
      </Box>
    </Card>
  );
};

export default ChartStationTJ;
